import { parse } from 'cookie';

export const getCookies = () => (typeof document !== 'undefined' ? parse(document.cookie) : {});
